<template>
  <div class="store_filter_container">
    <!--<div class="store_products">
            {{store ? 'Products' : 'Results'}} <span class="products_counter">{{ store? store.gotitCount : results }}</span>
    </div>-->
    <div v-if="!$device.isMobileOrTablet" class="strech" />
    <!--    <DebounceInputComponent :placeholder="'Search product'" @debounce="onSearchFilterChanged" class="search_product" />-->
    <dl v-if="pricesFilter.length > 0 && page !== 'store'" :class="{'show': showPriceRange}" class="price_range sort">
      <dt>
        <a href="#" class="filter_title" @click="togglePriceRange()">
          <span v-if="priceRangeFilter && !$device.isMobileOrTablet" class="reset" @click="clearFilter('price')">Reset</span>
          <span v-if="!priceRangeFilter || !$device.isMobileOrTablet">Price Range</span>
          <span v-if="priceRangeFilter">{{ (!$device.isMobileOrTablet ? ' - ' : '') + priceRangeFilter }}</span>
        </a>
      </dt>
      <dd>
        <ul>
          <li v-for="range in pricesFilter" ref="filtersRef" :key="range.id">
            <a
              v-if="range.id !== 'Any Price'"
              :class="{'highlight': priceRangeFilter === (range.toPrice ? '$' + range.fromPrice + ' - $' + range.toPrice : '$' + range.fromPrice + '+')}"
              @click="onPriceRangeClick(range)"
            >{{ range.toPrice ? '$' + range.fromPrice + ' - $' + range.toPrice : '$' + range.fromPrice + '+' }}</a>
            <a
              v-else
              :class="{'highlight': priceRangeFilter.toLowerCase() === 'any price'}"
              @click="onPriceRangeClick(range)"
            >{{ range.id }}</a>
          </li>
        </ul>
      </dd>
    </dl>
    <dl :class="{'show': showFilters}" class="sort main_filter">
      <dt>
        <a href="#" class="filter_title" @click="toggleFilters()">
          <span v-if="filterr && !$device.isMobileOrTablet" class="reset" @click="clearFilter('sort')">Reset</span>
          <span v-if="!filterr || !$device.isMobileOrTablet">Sort by</span>
          <span v-if="filterr">{{ (!$device.isMobileOrTablet ? ' - ' : '') + filterr }}</span>
        </a>
      </dt>
      <dd>
        <ul>
          <li v-for="filter in filters" ref="filtersRef" :key="filter.text">
            <a
              @click.stop="onFilterClick(filter)"
              :class="{'highlight': filter.text === filterr}"
              class="sub_menu_category"
            >{{ filter.text }}</a>
            <template v-if="['FILTER_BY_CATEGORY','FILTER_BY_SIZE'].includes(filter.filter)">
              <div v-if="['FILTER_BY_CATEGORY','FILTER_BY_SIZE'].includes(filter.filter)" class="strech" />
              <span v-if="$route.query.category && ['FILTER_BY_CATEGORY'].includes(filter.filter)" class="clear_category" @clik.stop="clearCategory()">clear</span>
              <img v-lazy-load data-src="/icons/arrow-right.svg" class="filter_icon">
            </template>
          </li>
        </ul>
      </dd>
    </dl>
    <dl v-if="page !== 'store'" :class="{'show': showGenderFilters}" class="sort gender">
      <dt>
        <a href="#" class="filter_title" @click="toggleGenderFilters()">
          <span v-if="genderFilter !== 'All' && !$device.isMobileOrTablet" class="reset" @click="clearFilter('gender')">Reset</span>
          <span v-if="genderFilter === 'All' || !$device.isMobileOrTablet">Gender</span>
          <span v-if="genderFilter !== 'All'">{{ (!$device.isMobileOrTablet ? ' - ' : '') + genderFilter }}</span>
        </a>
      </dt>
      <dd>
        <ul>
          <li v-for="filter in genderFilters" ref="filtersRef" :key="filter.text">
            <a
              :class="{'highlight': filter.text === genderFilter}"
              class="sub_menu_category"
              @click="onGenderClick(filter)"
            >{{ filter.text }}</a>
          </li>
        </ul>
      </dd>
    </dl>
    <div v-if="$device.isMobileOrTablet && !hideGridType" class="grid-type">
      <img v-lazy-load data-src="/icons/menu.svg" :class="{'selected' : feedType === 'feed'}" @click.stop="changeGridType('feed')">
      <img v-lazy-load data-src="/icons/apps.svg" :class="{'selected' : feedType === 'grid'}" @click.stop="changeGridType('grid')">
    </div>
  </div>
</template>

<script>
// import DebounceInputComponent from './DebounceInputComponent'
// import AuthenticatedPage from '~/components/AuthenticatedPage'

export default {
  name: 'SearchStoreFilterComponent',
  // eslint-disable-next-line vue/no-unused-components
  // extends: AuthenticatedPage,
  // components: { DebounceInputComponent },
  props: {
    page: {
      default: ''
    },
    category: {
      default: ''
    },
    hideGridType: {
      default: false
    },
    results: {
      default: 0
    },
    store: Object
  },
  data () {
    return {
      feedType: 'grid',
      filters: [
        { text: 'Newest', filter: '' },
        { text: 'Most Wanted', filter: 'MOST_WANTED' },
        { text: 'Most GOTit', filter: 'MOST_GOTIT' },
        { text: 'Price: Low-High', filter: 'PRICE_LOW' },
        { text: 'Price: High-Low', filter: 'PRICE_HIGH' },
        { text: 'Filter by category', filter: 'FILTER_BY_CATEGORY' },
        { text: 'Filter by size', filter: 'FILTER_BY_SIZE' }
      ],
      genderFilters: [
        { text: 'All', filter: '' },
        { text: 'Men\'s', filter: 'true' },
        { text: 'Women\'s', filter: 'false' }
      ],
      showFilters: false,
      showGenderFilters: false,
      pricesFilter: [{ id: 'Any Price', fromPrice: 1, toPrice: 1000 }, { id: 1, createdAt: 1438702956000, updatedAt: 1463860619000, fromPrice: 1, toPrice: 20 }, { id: 4, createdAt: 1438702966000, updatedAt: 1463860617000, fromPrice: 20, toPrice: 50 }, { id: 2, createdAt: 1438702974000, updatedAt: 1463860614000, fromPrice: 50, toPrice: 100 }, { id: 5, createdAt: 1438703080000, updatedAt: 1463860612000, fromPrice: 100, toPrice: 500 }, { id: 3, createdAt: 1438703085000, updatedAt: 1463860597000, fromPrice: 500, toPrice: null }],
      showPriceRange: false,
      searchInput: '',
      filterr: '',
      priceRangeFilter: '',
      genderFilter: 'All'
    }
  },
  watch: {
    category (newVal, oldVal) {
      if (this.priceRangeFilter === '' && this.genderFilter === 'All' && this.filterr === '') {
        return
      }
      this.priceRangeFilter = ''
      this.genderFilter = 'All'
      this.filterr = ''
      if (this.$router.currentRoute.name !== 'search') {
        this.$store.commit('api/setPriceRangeFilter', '')
        this.$store.commit('api/setGenderFilter', this.genderFilter)
        this.$store.commit('api/setSortFilter', '')
      }
      this.$emit('filterProducts', { type: 'filter' })
    }
  },
  mounted () {
    const sortFilter = this.$store.state.api.cache.sortFilter
    if (sortFilter) {
      this.filterr = sortFilter.text
      this.$emit('filterProducts', { type: 'filter', filter: sortFilter })
    }
    const genderFilter = this.$store.state.api.cache.genderFilter || 'All'
    if (genderFilter) {
      this.genderFilter = genderFilter.text || 'All'
      this.$emit('filterProducts', { type: 'genderFilter', filter: genderFilter.filter })
    }
    const range = this.$store.state.api.cache.priceRangeFilter
    if (range) {
      this.priceRangeFilter = range.toPrice ? '$' + range.fromPrice + ' - $' + range.toPrice : '$' + range.fromPrice + '+'
      this.$emit('filterProducts', { type: 'priceFilter', filter: range })
    }
  },
  methods: {
    clearCategory () {
      this.$router.replace({
        path: '/stores/' + this.encrypt(this.$route.params.id)
      })
    },
    onFilterClick (filter) {
      if (['FILTER_BY_CATEGORY', 'FILTER_BY_SIZE'].includes(filter.filter)) {
        this.$root.$emit('show_category_drawer', filter)
        return
      }
      this.filterr = filter.text
      this.toggleFilters()
      this.$store.commit('api/setSortFilter', filter)
      this.$store.state.api.cache.sortFilter = filter
      this.$emit('filterProducts', { type: 'filter', filter })
      this.$store.dispatch('api/trackEvent', {
        eventName: 'filter_clicked',
        params: {
          path: this.$route.path,
          type: 'sort'
        }
      }).then().catch()
    },
    changeGridType (type) {
      /* try {
        this.$store.commit('localStorage/saveFeedType', { type })
      } catch (e) {
      } */
      this.feedType = type
      this.$emit('changeGridType', type)
    },
    onGenderClick (filter) {
      this.genderFilter = filter.text
      this.toggleGenderFilters()
      this.$store.commit('api/setGenderFilter', filter)
      this.$emit('filterProducts', { type: 'genderFilter', filter: filter.filter })
      this.$store.dispatch('api/trackEvent', {
        eventName: 'filter_clicked',
        params: {
          path: this.$route.path,
          type: 'gender'
        }
      }).then().catch()
    },
    onPriceRangeClick (range) {
      this.priceRangeFilter = range.id === 'Any Price' ? range.id : range.toPrice ? '$' + range.fromPrice + ' - $' + range.toPrice : '$' + range.fromPrice + '+'
      this.togglePriceRange()
      this.$store.commit('api/setPriceRangeFilter', range)
      this.$emit('filterProducts', { type: 'priceFilter', filter: range })
      this.$store.dispatch('api/trackEvent', {
        eventName: 'filter_clicked',
        params: {
          path: this.$route.path,
          type: 'price'
        }
      }).then().catch()
    },
    toggleFilters () {
      this.showFilters = !this.showFilters
      this.showPriceRange = false
      this.showGenderFilters = false
    },
    toggleGenderFilters () {
      this.showGenderFilters = !this.showGenderFilters
      this.showPriceRange = false
      this.showFilters = false
    },
    togglePriceRange () {
      this.showPriceRange = !this.showPriceRange
      this.showFilters = false
      this.showGenderFilters = false
    },
    clearFilter (filter) {
      switch (filter) {
        case 'price': {
          this.priceRangeFilter = ''
          this.showPriceRange = false
          let counter = 0
          const interval = setInterval(() => {
            this.showPriceRange = false
            counter++
            if (counter > 20) {
              clearInterval(interval)
            }
          }, 50)
          this.$store.commit('api/setPriceRangeFilter', '')
          this.$emit('filterProducts', { type: 'priceFilter' })
          break
        }
        case 'gender': {
          this.genderFilter = 'All'
          this.showGenderFilters = false
          let counter = 0
          const interval = setInterval(() => {
            this.showGenderFilters = false
            counter++
            if (counter > 20) {
              clearInterval(interval)
            }
          }, 50)
          this.$store.commit('api/setGenderFilter', filter)
          this.$emit('filterProducts', { type: 'genderFilter' })
          break
        }
        case 'sort': {
          this.filterr = ''
          this.showFilters = false
          let counter = 0
          const interval = setInterval(() => {
            this.showFilters = false
            counter++
            if (counter > 20) {
              clearInterval(interval)
            }
          }, 50)
          this.$store.commit('api/setSortFilter', '')
          this.$emit('filterProducts', { type: 'filter' })
          break
        }
      }
    },
    onSearchFilterChanged (filter) {
      this.$emit('filterProducts', { type: 'search', filter: { text: filter } })
    }
  }
}
</script>

<style scoped>
  .store_filter_container {
    display: flex;
    border-top: 1px solid #d6d6d6;
    flex-direction: row;
    background-color: white;
    height: 60px;
    align-items: center;
    padding-right: 1em;
    /*font-family: 'HKGroteskBold', serif;*/
    font-weight: bold;
  }

  .mobile_design .store_filter_container {
    padding-left: 0;
    padding-right: 0;
    justify-content: space-between;
    height: 36px;
  }

  .strech {
    flex-grow: 1;
  }

  .sort {
    margin-top: 13.4em;
    /*z-index: 3;*/
  }

  .sort.main_filter {
    margin-top: 15.3em;
  }
  .store_products {
    border-bottom: 2px solid #ed4956;
    height: 60px;
    color: #ed4956;
    font-size: 16px;
    line-height: 60px;
    margin-left: 1em;
    text-align: center;
  }

  dt a {
    background: #EBECED;
    line-height: 36px;
    font-size: 14px;
    font-weight: 600;
    position: relative;
    border-radius: 5px;
    text-decoration: none;
    display: block;
    color: #373D48;
    padding: 0 28px 0 10px;
  }

  .mobile_design dt a {
    background: unset;
    color: #ed4956;
  }
  dt a:before {
    content: '';
    position: absolute;
    top: 50%;
    right: 10px;
    width: 9px;
    background: url("/ic_dropdown.svg") white no-repeat 50% 50%;
    height: 5px;
    opacity: 0.6;
    margin: -3px 0 0;
  }

  dt a:hover {
    text-decoration: none;
  }

  li {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    vertical-align: baseline;
    list-style: none;
    quotes: none;
    font-style: normal;
    outline: none;
    display: flex;
    -webkit-text-size-adjust: none;
    -webkit-overflow-scrolling: touch;
    -ms-text-size-adjust: none;
    text-size-adjust: none;
  }

  dd {
    position: relative;
    left: 3px;
    background: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 0 1px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    visibility: hidden;
    padding: 7px 0;
    min-width: calc(100% - 6px);
    opacity: 0;
    margin-top: 0;
    transition: opacity 0.3s;
    -webkit-transition: opacity 0.3s;
    -moz-transition: opacity 0.3s;
  }

  .mobile_design dd {
    width: 200px;
  }

  dl.show {
    z-index: 1;
    overflow: visible;
  }

  .store_page dl.show {
    z-index: 2;
  }

  dl.show dd {
    opacity: 1;
    visibility: visible;
  }

  li a {
    display: block;
    border-radius: 0;
    white-space: nowrap;
    background: none;
    border: 0;
    box-shadow: none;
    text-shadow: none;
    font-size: 13px;
    line-height: 17px;
    padding: 6px 13px;
    color: #383d48;
    font-weight: 600;
    text-transform: capitalize;
    cursor: pointer;
    z-index: 20;
  }

  .products_counter {
    opacity: 0.5;
    font-size: 14px;
  }

  .search_product {
    border: unset;
    margin-right: 1em;
    padding: 0.6em;
    border-radius: 5px;
    font-size: 15px;
    padding-left: 2.5em;
    background: url("/search.svg") #EBECED no-repeat 5% 50%;
  }

  .price_range {
    margin-right: 1em;
  }

  .main_filter {
    margin-right: 1em;
  }

  .mobile_design .price_range {
    margin-right: 0;
  }

  .mobile_design .main_filter {
    margin-right: 0;
  }

  .gender {
    margin-top: 7.3em;
  }

  .highlight {
    color: #ed4956;
  }

  .filter_title {
    display: flex;
    align-items: center;
  }

  .mobile_design .filter_title {
    font-size: 14px;
  }

  .mobile_design .sub_menu_category {
    font-size: 14px;
  }

  .filter_title img {
    margin-right: 0.3em;
    margin-top: 0.1em;
  }

  .clear_filter {
    height: 15px !important;
    width: 15px !important;
    display: inline-block;
    text-align: center;
    background-color: rgba(90, 93, 99, 0.47);
    border-radius: 50%;
  }

  .reset {
    margin-right: 1em;
    color: #ed4956;
  }

  .grid-type {
    display: flex;
    justify-content: space-around;
    justify-items: center;
    width: 50%;
  }

  .grid-type img {
    width: 24px;
    height: 24px;
  }

  .grid-type img.selected {
    width: 24px;
    height: 24px;
    filter: invert(35%) sepia(66%) saturate(1925%) hue-rotate(330deg) brightness(98%) contrast(89%);
  }

  .filter_icon {
    width: 15px;
    margin-right: 0.5em;
  }
</style>
